import { updateContent } from '../../Graphql/mutations'
import AppSyncClient from '../../Utils/AppSyncClient'

const UpdateContent = async parameters => {
	try {
		const { data } = await AppSyncClient.mutate({
			mutation: updateContent,
			variables: parameters,
			fetchPolicy: 'no-cache',
		})
		console.log('Success 12345', data)
		return data.updateContent
	} catch (error) {
		console.log('Error 12345', error)
		return error
	}
}

export default UpdateContent
